import Ajax from './http';

//获取APP列表
export function getToolListApi(values) {
	return Ajax.post('/tool/list', values);
}